const DI = {
	ISettings: Symbol('ISettings'),
	IModule: Symbol('IModule'),
	IView: Symbol('IView'),

	ProgressBar: Symbol('ProgressBar'),

	Translator: Symbol('Translator'),

	TextStyles: Symbol('TextStyles'),

	SpinButtonView: Symbol('SpinButtonView'),

	ViewManager: Symbol('ViewManager'),
	PixiStageContainer: Symbol('PixiStageContainer'),

	SoundManager: Symbol('SoundManager'),
	SoundPlayer: Symbol('SoundPlayer'),

	ObjectBuilder: Symbol('ObjectBuilder'),
	Logic: Symbol('Logic'),

	WinPresentationModule: Symbol('WinPresentationModule'),
	WinPresentationUtils: Symbol('WinPresentationUtils'),
	WinConfig: Symbol('WinConfig'),

	CheatModule: Symbol('CheatModule'),
	InfoPage: Symbol('InfoPage'),

	CurrencyFormatter: Symbol('CurrencyFormatter'),

	Layout: Symbol('Layout'),
};

export default DI;



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/common/inversify/constants/DI.ts